import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Row, Col, Layout, Tabs, Typography, Spin, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import moment from "moment";

import SecondaryHeaderComponent from "../../Header/student/secondaryHeader.component";
import StudentHeader from "../../Header/student/studentHeader.component";
import StudentTabMenu from "../../TabMenu/TabMenu";
import LiveExamTab from "./LiveExamTab";
import PracticeExamTab from "./PracticeExamTab";
import "./studentExams.page.style.css";
import {
  getStudentProfile,
  getGoupById,
  getSubjectByCourse,
  setVisible,
  setData,
} from "../../../stateManager/reducers/studentAuthSlice";
import { instance } from "../../../constants/constString";
import CourseCardForExam from "./CourseCardForExam";
import { getTabMenuData } from "./tabMenuData";
import { useHasInstantExam } from "./useHasInstantExam";

const { Header, Content } = Layout;
const { TabPane } = Tabs;
// eslint-disable-next-line no-unused-vars
const { Text } = Typography;
const PART = {
  COURSE: "course",
  EXAM: "exam",
};

const StudentCourses = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedSubjectPractice, setSelectedSubjectPractice] = useState();
  const [selectedSubject, setSelectedSubject] = useState();
  const [examList, setExamList] = useState("UpcomingExams");
  const [activeTab, setActiveTab] = useState("1"); // 1 = live exam , 2 = practice
  const [counter, setCounter] = useState(0);
  const allSubjects = useSelector((state) => state.studentAuth.allSubjects);
  const allExams = useSelector((state) => state.studentAuth.examList);
  const groupIds = useSelector((state) => state.studentAuth.groupIds);
  const _examsList = useSelector((state) => state.studentAuth.examList);
  const studentId = useSelector(
    (state) => state.studentAuth.studentProfile?._id
  );
  const [isLoading, setIsLoading] = useState(false);
  const [part, setPart] = useState(PART.COURSE);
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState();

  // Check if student has instant practice exams
  const { hasInstantExam } = useHasInstantExam();
  const tabMenuData = getTabMenuData(hasInstantExam);
  
  async function fetchGroups() {
      if (groupIds && groupIds.length > 0) {
        const promise = groupIds.map((item) => dispatch(getGoupById(item._id)));
        await Promise.all(promise);
      }
    }
  useEffect(()=>{
    const initializeFreshExamData = async () => {
      dispatch(setData({ key: 'examList', value: [] }));
      await fetchGroups()
    }
    initializeFreshExamData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[groupIds])
  // newly added
  // fetch course of that student
  useEffect(() => {
    const fetch = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get(
          "/student/courseByStudent/" + studentId
        );
        console.log(response?.data);
        setCourses(response?.data?.data ?? []);
      } catch (error) {
        return Promise.reject(error);
      } finally {
        setIsLoading(false);
      }
    };
    if (studentId && part === PART.COURSE) fetch();
  }, [part, studentId]);

  


  const onCourseCardClick = (selectedCourseItem) => {
    setPart(PART.EXAM) // so the student selected a course, not show him exam related to that course
    setSelectedCourse(selectedCourseItem)
    setSelectedSubjectPractice(undefined)
    setSelectedSubject(undefined)
    setExamList('UpcomingExams')
  }

  
  const liveExams = useMemo(
    () =>
      _examsList
        .filter((item) => item.examId?.isPracticeExam === false && item?.examId?.courseId === selectedCourse?._id)
        .sort(
          (a, b) =>
            moment(b?.startsAt).valueOf() - moment(a?.startsAt).valueOf()
        ),
    [_examsList, selectedCourse]
  );
  const practiceExam = useMemo(
    () =>
      _examsList
        .filter((item) => item.examId?.isPracticeExam === true && item?.examId?.courseId === selectedCourse?._id)
        .sort(
          (a, b) =>
            moment(b?.startsAt).valueOf() - moment(a?.startsAt).valueOf()
        ),
    [_examsList, selectedCourse]
  );

  // const liveExams = useSelector((state) =>
  //   state.studentAuth.examList
  //     .filter((item) => item.examId?.isPracticeExam === false)
  //     .sort(
  //       (a, b) => moment(b?.startsAt).valueOf() - moment(a?.startsAt).valueOf()
  //     )
  // );
  // const practiceExam = useSelector((state) =>
  //   state.studentAuth.examList
  //     .filter((item) => item.examId?.isPracticeExam === true)
  //     .sort(
  //       (a, b) => moment(b?.startsAt).valueOf() - moment(a?.startsAt).valueOf()
  //     )
  // );

  useEffect(() => {
    if (allExams && allExams.length > 0) {
      //
      localStorage.setItem("allExams", JSON.stringify(allExams));
    }
  }, [allExams]);

  useEffect(() => {
    if (location.state && location?.state?.isPracticeExam) {
      const tabKey = location?.state?.isPracticeExam === true ? "2" : "1";
      setActiveTab(tabKey);
    } else {
      setActiveTab("2");
    }
    if (location.state && location?.state?.examResultId) {
      setExamList("PreviousExams");
    } else {
      setExamList("UpcomingExams");
    }
  }, [location]);

  useEffect(() => {
    dispatch(setVisible(false));
    async function fetchData() {
      localStorage.removeItem("subjectOfSelectedExam");
      const res = await dispatch(getStudentProfile());
      if (res?.payload?.data) {
        const { courses } = res?.payload?.data;
        const promieses = courses.map((item) =>
          dispatch(getSubjectByCourse({ courseId: item?._id, forExam: true }))
        );
        await Promise.all(promieses);
      }
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    
    if (allExams.length === 0) fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupIds, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter(counter + 1);
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  });

  const changedSelect = (value) => {
    setExamList(value);
  };
  // this methods reference creation harmed child components memorization. thats why wrapped with use Callback
  const changedSelectedSubject = useCallback((value) => {
    setSelectedSubject(value);
  }, []);
  // this methods reference creation harmed child components memorization. thats why wrapped with use Callback
  const changeSelectedSubjectPractice = useCallback((value) => {
    setSelectedSubjectPractice(value);
  }, []);

  return (
    <Layout>
      <Header>
        <StudentHeader />
      </Header>
      <Layout>
        <SecondaryHeaderComponent />
      </Layout>
      <Layout>
        <Content className="custom-container section-padding sec-mh">
          <Row style={{ marginRight: 0, marginLeft: 0 }}>
            <Col xs={24}>
              <div className="desktop-student-tab">
                <StudentTabMenu selectedKey="exams" menuData={tabMenuData} />
              </div>
            </Col>
          </Row>
          {isLoading ? <Spin style={{width:'100%'}}/> :<></>}
          {part === PART.COURSE ? (
            <>
              <p>Choose course for exam information</p>
              <Row
                gutter={[16, 16]}
                style={{ marginRight: 0, marginLeft: 0, paddingBottom: 60 }}
              >
                {!!courses &&
                  courses.map((item, index) => (
                    <Col key={index} xs={24} md={8} lg={8} onClick={ () => onCourseCardClick(item)}>
                      <CourseCardForExam
                        data={item}
                      />
                    </Col>
                  ))}
              </Row>
            </>
          ) : (
           <>
           <div style={{display:"flex", alignItems:"center", gap:'10px'}}>
            <Button type="primary" onClick={() => setPart(PART.COURSE)} > Back </Button>
            <p style={{margin:0}}>Course : <span style={{fontWeight:600}}>{selectedCourse?.name}</span></p>
           </div>
            <Tabs
              className="studentExamTab"
              defaultActiveKey={activeTab}
              activeKey={activeTab}
              onChange={(activeKey) => setActiveTab(activeKey)}
            >
              <TabPane tab="Live Exam" key="1" style={{ position: "relative" }}>
                <LiveExamTab
                  courseId={selectedCourse?._id}
                  examList={examList}
                  liveExams={liveExams}
                  allSubjects={allSubjects}
                  selectedSubject={selectedSubject}
                  changedSelect={changedSelect}
                  changedSelectedSubject={changedSelectedSubject}
                />
              </TabPane>
              <TabPane
                tab="Practice Exam"
                key="2"
                style={{ position: "relative" }}
              >
                <PracticeExamTab
                  courseId={selectedCourse?._id}
                  practiceExam={practiceExam}
                  allSubjects={allSubjects}
                  selectedSubjectPractice={selectedSubjectPractice}
                  setSelectedSubjectPractice={changeSelectedSubjectPractice}
                />
              </TabPane>
            </Tabs>
           </>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default StudentCourses;
